// extracted by mini-css-extract-plugin
module.exports = {"banner":"GDPRBanner-module_banner_n1AYs","description":"GDPRBanner-module_description_13PbM","link":"GDPRBanner-module_link_2bIFe","button":"GDPRBanner-module_button_34MyV"};